<template>
<div class="card">
    <div class="card-header">
        <div class="card-header-title">
            {{ trans.title }}
        </div>
    </div>
    <div class="card-content field-label-container">
        <div class="mb-1">
            <h6>
                {{ trans.reset_instruction_title }}
            </h6>
            <div
                class="content is-size-7"
                v-html="trans.reset_instruction_text"
            ></div>
        </div>

        <div v-if="!isResetSuccess">
            <slot><!--CSRF token--></slot>

            <transition name="slide-fade">
                <div v-if="isEmailSent">
                    <div class="mb-1">
                        <p
                            class="has-text-weight-semibold has-text-success"
                            v-html="emailSentText"
                        ></p>
                    </div>

                    <div class="field is-horizontal mb-1">
                        <label for="reset-code" class="field-label is-normal">
                            {{ trans.reset_code }}
                        </label>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input
                                        id="reset-code"
                                        name="reset_code"
                                        class="input"
                                        autocomplete="off"
                                        required
                                        :class="[errors.reset_code ? 'is-danger' : '']"
                                        :placeholder="trans.reset_code_placeholder"
                                        v-model="form.reset_code"
                                        @keyup.enter="reset2Fa"
                                    >
                                </div>
                                <p v-show="errors.reset_code" class="help is-danger">
                                    {{ errors.reset_code }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>

            <div class="field is-horizontal">
                <label class="field-label"></label>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <button
                                class="button is-info"
                                :class="{ 'is-loading': isLoading }"
                                @click="sendResetCode"
                                v-show="!isEmailSent"
                            >
                                {{ trans.send_reset_code }}
                            </button>
                            <button
                                type="submit"
                                class="button is-info"
                                :class="[isLoading ? 'is-loading' : '']"
                                :disabled="isLoading"
                                v-show="isEmailSent"
                                @click="reset2Fa"
                            >
                                {{ trans.confirm }}
                            </button>
                            <a :href="this.actions.cancel" class="button is-outlined">
                                {{ trans.cancel }}
                            </a>
                        </div>
                    </div>
                    <p v-show="errors.unexpected" class="help is-danger">
                        {{ errors.unexpected }}
                    </p>
                </div>
            </div>

        </div>
        <p
            class="has-text-weight-semibold has-text-success"
            v-else
        >
            {{ trans.reset_success }}
        </p>
    </div>
</div>
</template>

<script>
    import { axiosForm } from '../mixins/axiosFormMixin.js';

    export default{
        mixins: [axiosForm],
        props: {
            email: String,
            actions: Object,
        },
        data() {
            return {
                isEmailSent: false,
                isResetSuccess: false,
                form: {
                    reset_code: null,
                },
                failReport: 'Ошибка сброса двухфакторной аутентификации',
            }
        },
        methods: {
            /**
             * Обработчик нажатия кнопки отправки кода
             */
            sendResetCode(e) {
                this.submit(e, this.actions.email, 'options');
            },

            /**
             * Обработчик нажатия кнопки подтверждения сброса 2fa
             */
            reset2Fa(e) {
                this.submit(e, this.actions.reset);
            },

            /**
             * Обработчик ответа сервера
             * @param response
             */
            postResultHandler(response) {
                if (response.data.sent) {
                    this.isEmailSent = true;
                }

                if (response.data.reset) {
                    sendGAEvent('Сброс двухфакторной аутентификации');
                    this.isResetSuccess = true;
                    window.location.reload();
                }
            },
        },
        computed: {
            emailSentText() {
                return this.trans.email_sent.replace(':email', this.email);
            },
        }
    }
</script>
